<template>

    <div class="classPageDiv">
  
      <div class=" mt-20 rounded overflow-x-scroll">
  
          <div v-if="classImages.length > 0" class="">
  
              <card-images-component :images="classImages" :isTransparent="false"/>
          </div>
  
          <div class="bookedSessionMapDiv">
  
              <div class="mt-2 mb-2 myCenter mycardBorder myMapLink">
                  <a :href="`${myClass.location.url}`"
                  class="">
                      {{$t('sessions.googleLink')}}
                  </a>
              </div>
  
              <location-booking-map class="w-full h-full" :location="myClass.location"></location-booking-map>            
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.className')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myClass.name}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.instructorName')}} </strong></label>
  
              
              <label
              class="classPageDetailsLabel">
              {{myClass.instructor_name}}</label>
          </div>
  
          <div v-if="myClass.pay_cash" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.cash')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myClass.cash_cost}}</label>
          </div>
  
          <div v-if="myClass.pay_points" class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.points')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{myClass.points_cost}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.level')}} </strong></label>
              
              <label
              class="classPageDetailsLabel">
              {{myClass.level}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.type')}} </strong></label>
  
              <label
              class="classPageDetailsLabel">
              {{type}}</label>
          </div>
  
          <div class="classPageRow">
                          
              <label class="mr-5"><strong>{{$t('classes.description')}} </strong></label>
  
              <p
              class="classPageDetailsLabel">
              {{myClass.description}}</p>
          </div>

          <div>

            <div  class="mb-40" v-if="stopLoader && (classInfo != null ||  typeof stopLoader == 'undefined')">

                <div :key="lastSelectedIndex">
                                
                    <!-- <my-date-bar :myDates="myDates"/> -->
                    <my-date-bar :myDates="myDates" :setDate="setDateFromBar" :fromPage="true"
                     :useWithPanel="true" :lastSelectedIndex="lastSelectedIndex"/>
                </div>  

                <div class="mt-4 mySessionsDivider" :key="panelObject.dayDate">

                    <div class="myCardDiv" ref="slotRef" v-for="(oneSlot, index) in panelObject.categorizedSlots" :key="index">

                        <session-class-page-card :tokenId="tokenId" :key="panelObject.dayDate" :isOnline="true"
                        :email="email" :myReload="myReload" :isCard="false"
                        :mySlot="oneSlot" :index="index" :dayDate="panelObject.dayDate"
                        :disableButton="disableButton" :myClass="classInfo"/>
                    </div>     
                </div>


            <!-- <div class="w-full flex justify-center bg-white border-blue-800 border-4 p-2 mt-4">        
                <button class="myClassBookingCardBorder myClassBookButton" @click="callBooking">

                    <label v-if="false">{{$t('memberships.join')}}</label>

                    <label v-else>{{$t('sessions.book')}}</label>                    
                </button>
            </div>               -->
            </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    
  
  import componentsHelpers from '../../classes/componentHelpers';
  
  import LocationBookingMap from '../../components/LocationBookingMap'
  
  import SessionClassPageCard from './SessionClassPageCard.vue'

  import cardImagesComponent from '../../components-v2/cards-components/CardImages';
  
  import myQueries from '../../hasura/myQueries';
  
  import myInserts from '../../hasura/myInserts';
  
  import moment from 'moment'
  
  import componentsMethods from '../../classes/componentsMethods';
  
  import myDateBar from '../../components-v2/Bars/MyDatesBar'
  
  import axios from '@/classes/myAxios'
  
  // import MyTabs from '../components-v2/controls/MyTabs';
  
  export default {
  
      created()
      {
            
          // console.log(`myClass: ${JSON.stringify(this.myClass)}`);
      },
  
      async mounted(){

        await this.loadData();
            // console.log(`in public class page`);
  
              // console.log(`class: ${JSON.stringify(this.myClass)}`);
          try{
  
              if(this.myClass.image_1 != null && this.myClass.image_1 != ''){
  
                  this.classImages.push(this.myClass.image_1);
  
                  if(this.myClass.image_2 != null && this.myClass.image_2 != ''){
  
                      this.classImages.push(this.myClass.image_2);
                      
                      if(this.myClass.image_3 != null && this.myClass.image_3 != ''){
  
                          this.classImages.push(this.myClass.image_3);
  
                          if(this.myClass.image_4 != null && this.myClass.image_4 != ''){
  
                              this.classImages.push(this.myClass.image_4);
  
                              if(this.myClass.image_5 != null && this.myClass.image_5 != ''){
  
                                  this.classImages.push(this.myClass.image_5);
  
                                  if(this.myClass.image_6 != null && this.myClass.image_6 != ''){
  
                                      this.classImages.push(this.myClass.image_6);
  
                                      if(this.myClass.image_7 != null && this.myClass.image_7 != ''){
  
                                          this.classImages.push(this.myClass.image_7);
  
                                          if(this.myClass.image_8 != null && this.myClass.image_8 != ''){
  
                                              this.classImages.push(this.myClass.image_8);
                                          }
                                      }
                                  }
                              }
                          }
                      }
                  } 
              }
  
              // console.log(`this.classImages: ${JSON.stringify(this.classImages)}`);
  
              this.setType();
  
  
          // console.log(`dates: ${JSON.stringify(dates)}`);
  
          }catch(error){
  
              componentsHelpers.sendError(this.$apollo, this.userId,'v2-ClassPage', 'classPage', 'mounted - catch 1', error);
  
              componentsHelpers.toastIt(this.$toasted, this.$t('home.errorToAdmin'), 3, 'outline', true);
          }
      },
  
      props: {
  
          isIos:{
              
              type: Function 
          },
  
          lastDayDate: '',
  
          showPanel: false,
  
          closeClassPage: {
  
              type: Function 
          },
  
          myClass:{
          
              type: Object,
              default: () => ({})
          },
  
          myReload: {
  
              type: Function
          },
      },
  
      components: {
  
          cardImagesComponent,
          SessionClassPageCard,
          myDateBar,
          LocationBookingMap
      },
  
      methods: {

        async loadData(){
            
            try{

                this.stopLoader = false;

                    let result = await axios({method: 'post',url: '/pnadiapi/forPublicInfo/getClass',
                        data: {
                            
                            classId: this.myClass.id
                        }
                    });

                const data = result.data;

                // console.log(`apollo class: ${JSON.stringify(  data.class[0])}`)

                this.classInfo = data.class[0];

                this.listOfWeekDays =  componentsMethods.findWeekDays(this.classInfo.slots);

                // console.log(`listOfWeekDays: ${JSON.stringify(this.listOfWeekDays)}`);

                this.myDates = componentsMethods.getDates(this.listOfWeekDays);

            //   console.log(`this.myDates: ${JSON.stringify(this.myDates)}`);
                this.checkLastSelectedDayDate();
                
                this.classSlots = this.classInfo.slots;
                
                this.panelObject.categorizedSlots = this.classSlots.filter(item=> item);
                this.stopLoader = true;

                // console.log(`categorizedSlots.length: ${this.panelObject.categorizedSlots.length}`);

                // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);
                // return data.class;
            }catch(error){
                
                this.stopLoader = true;
            }
        },

  
          checkLastSelectedDayDate(){
  
              // console.log(`in class page, ${this.lastDayDate}`);
  
            //   console.log(`this.myDates: ${JSON.stringify(this.myDates)}`);
  
              if(this.lastDayDate != ''){
  
                  const tempDate = this.lastDayDate;
  
                  this.lastSelectedIndex =  this.myDates.findIndex(item=> item.date == tempDate);
  
                //   console.log(`lastSelectedIndex: ${JSON.stringify(this.lastSelectedIndex)}`);
              }
          },
  
          callBooking(){
  
          },
  
  
          setType(){
                  
              const types = this.myClass.categories;
  
              for(let i = 0; i < types.length; i++){
  
                  if(i != types.length - 1){
                      
                      this.type = this.type + types[i].category.name + ', '
                  }
                  else {
                  
                  this.type = this.type + types[i].category.name;
                  }
              }
  
              return this.type;
          }, 
  
          setDateFromBar(date){
  
            //   console.log(`setDateFromBar: ${date}`);
              // this.panelObject.dayDate = date;
  
              const tempDate = moment(date).format(moment.HTML5_FMT.DATE);
              this.panelObject.dayDate = tempDate;
              // console.log(`date: ${this.panelObject.dayDate}`);
  
              // this.$refs.sessionsPanel.setNewDate(tempDate)
              this.setSlots();
          },
  
           setSlots(){
              
              // console.log(`allSlots: ${JSON.stringify(this.allSlots)}`)
              const selectionDay = this.dayOfWeekAsString(new Date(this.panelObject.dayDate).getDay());
  
              const equalMethod = componentsMethods.isEqualToWeeKDayForSession;
              
              const weekDayFilter = item => equalMethod(item, selectionDay, this.panelObject.dayDate);
  
              if(this.onlyOnline){
  
                  const justOnlineSlots = this.classSlots.filter(item => item.class.is_online == true);
                  
                  this.weekDayCategorizedSlots = justOnlineSlots.filter(weekDayFilter);
              }
              else{
  
                  this.weekDayCategorizedSlots = this.classSlots.filter(weekDayFilter);
              }
  
              this.timedCategorizedSlots = this.weekDayCategorizedSlots.filter(item => item);
              componentsMethods.sortTimes(this.timedCategorizedSlots);
  
              this.panelObject.categorizedSlots = this.timedCategorizedSlots;
  
              // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`);
  
              // console.log(`date: ${this.panelObject.dayDate}`)
  
              // console.log(`categorizedSlots: ${JSON.stringify(this.panelObject.categorizedSlots)}`)
          },
  
          dayOfWeekAsString(dayIndex) {
          
              return [this.$t('slot.sunday'), this.$t('slot.monday'), this.$t('slot.tuesday'),this.$t('slot.wednesday'),this.$t('slot.thursday'),this.$t('slot.friday'),this.$t('slot.saturday')][dayIndex];
          },
          
      },

  
      data: function() {
  
          return {
              
              panelObject:{
  
                  minimizeAll: false,
                  onlyOnline: false,
                  categorizedSlots: new Array(),
                  dayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              },
              stopLoader: false,
              listOfWeekDays: [false, false, false, false, false, false, false],
              classInfo: null,
              user:[],
              classImages: [],
              fixedDayDate: moment(new Date()).format(moment.HTML5_FMT.DATE),
              type: '',
              showBusiness: false,
              showInstructor: false,
              userQueryError: '',            
              slotQueryError: '',
              tokenId: '',
              email: '',
              userId: 0,
              myDates: [],
              classSlots: [],
              disableButton: false,
              lastSelectedIndex: 0,
              storedKey: localStorage.getItem('for_pnadi'),
  
          }
      },  
  }
  </script>
  
  <style lang="scss">
  
  label{
    width: 150px;
  }
  
  
  </style>